<template>
  <h1 class="text-lg">
    <slot> </slot>
  </h1>
</template>

<script>
export default {
  name: "LargeTitle",
  components: {},
};
</script>

<style>
</style>